import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Configurações SEO por rota
const SEO_CONFIG = {
  '/': {
    title: 'Quatro Takes',
    description: 'Descubra as melhores análises de filmes, séries e conteúdo audiovisual com nossa equipe especializada. Críticas honestas e profundas sobre cinema.',
    keywords: 'críticas de cinema, filmes, séries, entretenimento, análise de filmes, cinema brasileiro, resenhas, Quatro Takes'
  },
  '/criticas': {
    title: 'Críticas de Filmes e Séries - Quatro Takes',
    description: 'Leia as melhores críticas de filmes e séries. Análises detalhadas, sem spoilers, com nossa opinião honesta sobre as produções mais recentes do cinema.',
    keywords: 'críticas de filmes, críticas de séries, resenhas, análise de cinema, filmes 2024, séries 2024, Quatro Takes'
  }
};

export const useSEO = () => {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    const config = SEO_CONFIG[path] || SEO_CONFIG['/'];
    
    // Atualizar título
    document.title = config.title;
    
    // Atualizar meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = config.description;
    
    // Atualizar meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = config.keywords;
    
    // Atualizar Open Graph
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.content = config.title;
    
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.content = config.description;
    
    // Atualizar URL canônica
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `https://quatrotakes.com${path}`;
    
    // Scroll para o topo
    window.scrollTo(0, 0);
    
  }, [location]);
  
  return SEO_CONFIG[location.pathname] || SEO_CONFIG['/'];
};
